import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Informes/estadoCentro`, method: 'POST', body: list, token: token})
}